import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

const Facilities = () => {
  return (
    <div>
      <Container>
        <h3 className='text-center mt-5 mb-5'>Our Infrastructure & Facilities</h3>
        <Row>
          <h5 className='text-center mt-5 mb-5' >Labs</h5>
          <Col>
          </Col>
        </Row>
        <Row>
          <h5 className='text-center mt-5 mb-5' >Playground</h5>
          <Col>
          </Col>
        </Row>
        <Row>
          <h5 className='text-center mt-5 mb-5' >Library</h5>
          <Col>
          </Col>
        </Row>
        <Row>
          <h5 className='text-center mt-5 mb-5' >Classrooms</h5>
          <Col>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Facilities